var map = {
	"./icons/icon-add": 5,
	"./icons/icon-add.svg": 5,
	"./icons/icon-arrow-back": 6,
	"./icons/icon-arrow-back.svg": 6,
	"./icons/icon-arrow-pagination-next": 7,
	"./icons/icon-arrow-pagination-next.svg": 7,
	"./icons/icon-arrow-pagination-prev": 8,
	"./icons/icon-arrow-pagination-prev.svg": 8,
	"./icons/icon-arrow-right": 9,
	"./icons/icon-arrow-right-small": 10,
	"./icons/icon-arrow-right-small.svg": 10,
	"./icons/icon-arrow-right.svg": 9,
	"./icons/icon-arrow-slider-left": 11,
	"./icons/icon-arrow-slider-left.svg": 11,
	"./icons/icon-arrow-slider-next": 12,
	"./icons/icon-arrow-slider-next.svg": 12,
	"./icons/icon-arrow-slider-prev": 13,
	"./icons/icon-arrow-slider-prev.svg": 13,
	"./icons/icon-arrow-slider-right": 14,
	"./icons/icon-arrow-slider-right.svg": 14,
	"./icons/icon-arrow-timeline": 15,
	"./icons/icon-arrow-timeline.svg": 15,
	"./icons/icon-close": 16,
	"./icons/icon-close.svg": 16,
	"./icons/icon-document": 17,
	"./icons/icon-document.svg": 17,
	"./icons/icon-file": 18,
	"./icons/icon-file.svg": 18,
	"./icons/icon-pause": 19,
	"./icons/icon-pause.svg": 19,
	"./icons/icon-play": 20,
	"./icons/icon-play.svg": 20,
	"./icons/icon-profile": 21,
	"./icons/icon-profile.svg": 21,
	"./icons/icon-reset": 22,
	"./icons/icon-reset.svg": 22,
	"./icons/icon-sandwich": 23,
	"./icons/icon-sandwich-close": 24,
	"./icons/icon-sandwich-close.svg": 24,
	"./icons/icon-sandwich.svg": 23,
	"./icons/icon-select": 25,
	"./icons/icon-select.svg": 25,
	"./icons/icon-slider-back": 26,
	"./icons/icon-slider-back.svg": 26,
	"./icons/icon-social-fb": 27,
	"./icons/icon-social-fb.svg": 27,
	"./icons/icon-social-inst": 28,
	"./icons/icon-social-inst.svg": 28,
	"./icons/icon-social-vk": 29,
	"./icons/icon-social-vk.svg": 29,
	"./icons/icon-social-ytube": 30,
	"./icons/icon-social-ytube.svg": 30,
	"./icons/icon-type": 31,
	"./icons/icon-type.svg": 31,
	"./icons/loading": 32,
	"./icons/loading.svg": 32,
	"./logo/fb": 33,
	"./logo/fb.svg": 33,
	"./logo/instagram": 34,
	"./logo/instagram.svg": 34,
	"./logo/logo-1tvch": 2,
	"./logo/logo-1tvch-en": 3,
	"./logo/logo-1tvch-en.png": 3,
	"./logo/logo-1tvch-en.svg": 53,
	"./logo/logo-1tvch.png": 2,
	"./logo/logo-1tvch.svg": 54,
	"./logo/ok": 35,
	"./logo/ok.svg": 35,
	"./logo/vk": 36,
	"./logo/vk.svg": 36,
	"./logo/vk_b": 37,
	"./logo/vk_b.svg": 37,
	"./logo/yt": 38,
	"./logo/yt.svg": 38,
	"./main-adv/digital": 39,
	"./main-adv/digital-mobile": 40,
	"./main-adv/digital-mobile.svg": 40,
	"./main-adv/digital.svg": 39,
	"./main-adv/events": 41,
	"./main-adv/events.svg": 41,
	"./main-adv/sponsors": 42,
	"./main-adv/sponsors.svg": 42,
	"./main-adv/top": 43,
	"./main-adv/top.svg": 43,
	"./main-adv/tv": 44,
	"./main-adv/tv.png": 44,
	"./og": 45,
	"./og.png": 45,
	"./top-adv/bg-top-adv": 46,
	"./top-adv/bg-top-adv.svg": 46
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52;